import { AssetAssetCaseAttributes } from '@/types'
import { RemoveAssetFromCaseMutation } from './__generated__/remove_asset_mutation'
import { Mutation as RemoveMutation } from './remove_asset_mutation'
import { useForm } from '@/helpers/useForm'
import { Query as TableQuery } from '@/components/asset/table_query'

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<RemoveAssetFromCaseMutation, AssetAssetCaseAttributes, never, never>({
    id,
    defaultValues: {
      barcode: ''
    },
    mutation: RemoveMutation,
    resultKey: 'removeAssetFromCase',
    refetchQueries: [TableQuery]
  })

  return (
    <>
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Remove an asset by barcode', field: 'barcode', type: 'text' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess, 'Remove asset from case', 'red') }
      </div>
    </>
  )
}
